// TODO: refactor env variables names ( use unified names )
export const environment = {
  production: true,
  version: "0.0.1 (beta)",
  graphql_endpoint: "https://dev-rentalab-graph.fth.dev/graphql",
  url: "https://dev-rentalab-file.fth.dev",
  skip_auth: false,
  REPORT_URL: "https://dev-queue-customer-report.example.com/download-report",
  firebase: {
    apiKey: "AIzaSyCmm-Lmu3-DKgzKEjdGtvg1CgSJBhe5IOU",
    authDomain: "rentalab0.firebaseapp.com",
    projectId: "rentalab0",
    storageBucket: "rentalab0.firebasestorage.app",
    messagingSenderId: "334590255562",
    appId: "1:334590255562:web:130e54f1e34dfb28dfaf33",
    measurementId: "G-14CP7MP8J7",
  },
  VAPIDKEY: "BPyX6QRX7k4iJ1tVKLd9vyj4_2Fct8ir71171fo4mYcjRqhUMjU40ukFi2AihdaEcFv2zYHQmIe3mzMKrMV01OQ",
  routes_api_key: "AIzaSyDeJ5xM143_LxsyxSacy36EVeBALiaRbdY",
  GOOGLE_SCRIPT: "https://maps.googleapis.com/maps/api/js",
  google_api_key: "AIzaSyBoS4i64ogUk5NXQR8IPr_w2eF1dwhdrdo",
  places_key: "AIzaSyBoS4i64ogUk5NXQR8IPr_w2eF1dwhdrdo",
  RECAPTCHA_SITE_KEY: "6LeUBfIqAAAAAH5_1-A5ulkA3uUNUPx-wnyLJniV",
  RECAPTCHA_SECRET_KEY: "6LeUBfIqAAAAAPFHAKKakGsL-O9WiLGgwnGOWOHn",
  RECAPTCHA_API_URL: "https://www.google.com/recaptcha/api.js?render=explicit",
  REALTIME_SOCKET_URL: "https://dev-rentalab-realtime.fth.dev",
  CRM_SOCKET_URL: "https://dev-queue-customer-crm.example.com",
  GEO_SERVICE_URL: "https://dev-queue-customer-geo.example.com",
  SHOW_SENTRY_REPORT_BUTTON: true,
  // Noleggiare's public online check-in form — opened in a new tab by the
  // save-time CTA on the customer ticket page.
  WEB_CHECKIN_URL: "https://www.noleggiare.it/it/webcheckin/",
};
